import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {BigintDisplayDecimalPipe} from '../../components/bigint-display-decimal-pipe/bigint-display-decimal.pipe';
import {CopyTooltipModule} from '../../components/copy-tooltip/copy-tooltip.module';
import {DeliverableInputComponent} from '../../components/deliverable-input/deliverable-input.component';
import {DexTrancheUtilityModule} from '../../components/dex/dex-tranche-utility/dex-tranche-utility.module';
import {DelBalanceAsyncPipe} from '../../components/dex/dyn-balances/del-balance-async.pipe';
import {WalletAvatarComponent} from '../../components/dex/wallet-avatar/wallet-avatar.component';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {ShortenWalletAddrPipe} from '../../components/dynamic-xyz/utils/shorten-wallet-addr.pipe';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {SelectAllOnFocusModule} from '../../components/select-all-on-focus';
import {SelectInputModule} from '../../components/select-input';
import {TooltipModule} from '../../components/tooltip';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {DecimalInputModule} from '../../directives/decimal-input';
import {TextHidingModule} from '../../directives/text-hiding';
import {OrderTotalBlockModule} from '../components/order-total-block';
import {SelectAccountModule} from '../components/select-account';
import {DelBuyMinMaxQtyPipe} from './del-buy-min-max-qty.pipe';
import {DelMinQtyPipe} from './del-min-qty.pipe';
import {DEX_LP_TRADE_WIDGET_DESCRIPTION} from './dex-lp-trade-widget-description';
import {DexLpTradeWidgetComponent} from './dex-lp-trade-widget.component';
import {DexLpTradeWidgetSettingsService} from './settings';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        SelectAccountModule,
        SelectInputModule,
        FormsModule,
        AutofocusModule,
        DecimalInputModule,
        DisplayDecimalModule,
        OrderTotalBlockModule,
        BigintDisplayDecimalPipe,
        DeliverableInputComponent,
        BigintDeliverableDisplayDecimalPipe,
        DelMinQtyPipe,
        ShortenWalletAddrPipe,
        DelBalanceAsyncPipe,
        DexTrancheUtilityModule,
        SelectAllOnFocusModule,
        DelBuyMinMaxQtyPipe,
        WalletAvatarComponent,
        CopyTooltipModule,
        TooltipModule,
        TextHidingModule
    ],
    declarations:    [
        DexLpTradeWidgetComponent
    ],
    exports:         [
        DexLpTradeWidgetComponent
    ],
    providers:       [
        DexLpTradeWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_LP_TRADE_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexLpTradeWidgetModule {}
